import _ from "lodash";
import * as projectTypes from "@/helpers/projectTypes";

const initialState = () => ({
  fixed_selected_types: [],
  formdata: {
    project_addons: [],
    project_types: [],
    price_overrides: {}
  },
  project_addons: [],
  project_types: [],
  data_fetching: false
});

export default {
  namespaced: true,
  state: initialState,
  getters: {
    is_electrical_stamp: state => {
      const project_types = _.get(state, "formdata.project_types", []);
      const projectType = projectTypes.electricalStamp();

      if (projectType) {
        return (
          project_types.length >= 1 &&
          !!_.find(project_types, { id: projectType.value })
        );
      }

      return false;
    }
  },
  mutations: {
    INITIALIZE_CHANGEORDER: (state, selected_project_types) => {
      let array = [];

      selected_project_types.forEach(item => {
        array.push(state.project_types.find(type => type.id === item));
      });

      state.formdata.project_types = _.cloneDeep(array);
      state.fixed_selected_types = _.cloneDeep(array);
    },

    SET_PROJECT_TYPES: (state, { project_types }) =>
      (state.project_types = project_types),

    SET_FORMDATA_PROJECT_TYPES: (state, { project_types }) =>
      (state.formdata.project_types = _.orderBy(
        project_types,
        ["name"],
        ["asc"]
      )),

    SET_FORMDATA_PROJECT_ADDONS: (state, { project_addons }) =>
      (state.formdata.project_addons = _.orderBy(
        project_addons,
        ["name"],
        ["asc"]
      )),

    SET_DATA_FETCHING: (state, payload) => (state.data_fetching = payload),

    SET_PROJECT_ADDONS: (state, { project_addons }) =>
      (state.project_addons = project_addons),

    RESET_FORMDATA_PROJECT_ADDONS: state =>
      (state.formdata.project_addons = []),

    SET_PRICE_OVERRIDE: (state, { id, price }) => {
      const overrides = { ...state.formdata.price_overrides };
      if (price === null || price === undefined || price === "") {
        delete overrides[id];
      } else {
        overrides[id] = price;
      }
      state.formdata.price_overrides = overrides;
    },

    RESET_PRICE_OVERRIDES: state => {
      state.formdata.price_overrides = {};
    }
  },
  actions: {}
};
